// @ts-nocheck

export const ModalDimension = {
  XSMALL: {
    maxHeight: 260,
    maxWidth: 300,
  },
  SMALL: {
    maxHeight: 300,
  },
  TABLET: {
    maxHeight: 500,
  },
  DESKTOP: {
    height: 650,
    maxHeight: 900,
    width: 500,
    maxWidth: 600,
  },
};

export const ModalFormat = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  DESKTOP: 'desktop',
  FULLSCREEN: 'fullscreen',
};

export const ModalContentSpacing = {
  NONE: 0,
  XSMALL: 10,
  SMALL: 20,
  MEDIUM: 30,
  LARGE: 40,
};

// 80 refers to the add of 2 x 40px (40px for each side of the screen: left and right)
export const ModalSpacing = {
  PADDING: 80,
};
